'use client';

import SEO from '@/components/SEO';
import { useParams, useRouter } from 'next/navigation';
import Image from 'next/image';
import DumbLink from '@/components/DumbLink';
import { Button } from '@/components/ui/button';

export default function NotFoundView() {
  const router = useRouter();
  const params = useParams();
  const home = params?.country ? `/${params.country}` : '/';
  const handleGoBack = () => router.back();
  return (
    <div className="flex flex-col justify-center items-center px-4 min-h-screen">
      <SEO
        title="Oops! Page not found"
        description="We're sorry, but the page you requested could not be found. Please check the URL, or return to the home page."
      />

      <Image
        src="/assets/images/404.svg"
        alt="404 Error"
        width={320}
        height={320}
      />

      <p className="text-sm mt-4">The page you are looking for does not exist.</p>
      <div className="flex flex-wrap gap-2 mt-4">
        <Button variant="outline" onClick={handleGoBack}>
          Go Back
        </Button>
        <Button asChild>
          <DumbLink href={home}>Continue Shopping at BuyWisely</DumbLink>
        </Button>
      </div>
    </div>
  );
}
